import { Outlet } from 'react-router-dom';
import { TopBar } from '../components/TopBar';
import { Sidebar } from '../components/Sidebar';

/**
 * 工作空间外壳：包裹整个空间内部页面
 */
export function WorkspaceLayout() {
  return (
    <div className="flex h-screen flex-col">
      <TopBar />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 overflow-auto bg-bg-canvas">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
